import React from "react";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import ABBLogin from "./pages/cognien-pages/login/login";
import Dashboard from "./pages/dashboard/dashboard";
import ChangePassword from "./pages/cognien-pages/change-password/change-passoword";
import Signup from "./pages/cognien-pages/signup/signup";
import ForgotPassword from "./pages/cognien-pages/forgot-password/forgot-password";
import NetZeroDashboard from "./pages/net-zero";
import MicrogridOpti from "./pages/micro-grid-opt";
import InputParameterSettings from "./pages/micro-grid-opt/input-parameters";
import ProoferTool from "./pages/proofer-pages";
import ProoferDashboard from "./pages/proofer-pages/dashboard/dashboard";
import ProoferTabs from "./components/proofer-tool-cmps/popup-output-tabs/popup-output-tabs";
import NetworkPreview from "./components/Microgrid-Opt-Components/Network/network-preview";
import WNTDashboard from './pages/wide-area-network-twin';
import ConfigureSLD from './pages/wide-area-network-twin/configure-sld';
import SiteExplorer from "./pages/substation-explorer";
import CyberShield from './pages/cybershield';
import Navbar from "./components/Navbar/navbar";
import CognienDashboard from "../src/pages/cognien-pages/dashboard/dashboard";
import SubstationExplorer from "../src/pages/cognien-pages/substation-explorer";
import CognienNavbar from "./components/cognien-components/Navbar/navbar";
import ManageUsers from "../src/pages/cognien-pages/user-management/manage-users";
import FullSld from "./components/cognien-components/SLD/full-sld";
import EditUser from "./pages/cognien-pages/user-management/edit-user";
import EvciEds from './pages/evci-eds';
import SolarEnergyDashboard from "./pages/solar-energy";

// Component to conditionally render navbar
function AppLayout() {
  const location = useLocation();

  // Define routes where navbar should be shown
  const navbarRoutes = [
    '/settings',
    '/substation-explorer',
    '/substation-dashboard',
    '/sld-preview',
    '/edit-user'
  ];

  // Check if current path matches any navbar route
  const shouldShowNavbar = navbarRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      {shouldShowNavbar && (
        <>
          <Navbar />
          {/* <CognienNavbar /> */}

        </>

      )}
      <Routes>
        {/* Home Page */}
        <Route exact path="/" element={<ABBLogin />} />

        {/* Login and Auth Routes */}
        <Route exact path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />

        {/* Dashboard pages */}
        <Route path="/" element={<SiteExplorer />} />
        <Route path="/site-explorer" element={<SiteExplorer />} />

        {/* Routes with Navbar */}
        <Route path="/settings" element={<ManageUsers />} />
        <Route path="/substation-explorer" element={<SubstationExplorer />} />
        <Route path="/substation-dashboard/*" element={<CognienDashboard />} />
        <Route path="/sld-preview" element={<FullSld />} />
        <Route path="/edit-user/*" element={<EditUser />} />

        {/* Modules */}

        {/* SMDemo - DR Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/highcharts" element={<Dashboard />} />

        {/* EM Widgets */}
        <Route path="/em" element={<Dashboard />} />

        {/* Net Zero */}
        <Route path="/nz" element={<NetZeroDashboard />} />

        {/* WNT */}
        <Route path="/wnt" element={<WNTDashboard />} />
        <Route path="/wnt/configure-sld" element={<ConfigureSLD />} />


        {/* Microgrid */}
        <Route path="/network-preview" element={<NetworkPreview />} />
        <Route path="/microgrid-opt" element={<MicrogridOpti />} >
          <Route path="/microgrid-opt/input-settings" element={<InputParameterSettings />} />
        </Route>

        {/* Proofer tool */}
        <Route path="/proofer-tool" element={<ProoferTool />} >
          <Route path="/proofer-tool/popup-output-tabs" element={<ProoferTabs />} />
        </Route >

        {/* CyberShield */}
        <Route path="cyber-shield" element={<CyberShield />} />

        {/* EVCI EDS */}
        <Route path="evci-eds" element={<EvciEds />} />

        {/* <Route path="/solar-energy" element={<SolarEnergyDashboard />} /> */}
      </Routes>
    </>
  );
}

function CogniENRoutes() {
  return (
    <HashRouter>
      <AppLayout />
    </HashRouter>
  );
}

// Make sure to export as default
export default CogniENRoutes;